import React, { useState } from "react";
import { AiOutlineLogout } from "react-icons/ai";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";

export default function MediaSidebarItem({ item, onClick, isRoot = false }) {
  const [open, setOpen] = useState(false);
  const [sidebar, setSidebar] = useState(false);

  const authState = useSelector((state) => state?.auth);
  const user = authState?.user?.user ? authState?.user?.user : authState?.user;
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const showSideBar = () => {
    setSidebar(!sidebar);
    onClick();
  };

  // 🧠 Recursive structure for nested items
  if (item.title === "My Account") {
    return (
      <div className={user === null ? "d-none" : "sidebar-item"}>
        <div className="sidebar-title">
          <span>
            {item.icon && <item.icon className="sidebar-icon" />} {/* ✅ fixed */}
            {item.title}
          </span>
          <i
            className="bi-chevron-down toggle-btn"
            onClick={() => setOpen(!open)}
          ></i>
        </div>
        <div className={open ? "sidebar-content open" : "sidebar-content"}>
          {item.childrens.map((child, index) => (
            <MediaSidebarItem key={index} item={child} onClick={showSideBar} />
          ))}
        </div>
      </div>
    );
  }

  if (item.childrens) {
    return (
      <div className={open ? "sidebar-item open" : "sidebar-item brands__dropdown"}>
        <div className="sidebar-title">
          <span>
            {item.icon && <item.icon className="sidebar-icon" />} 
            {item.title} 
          </span>
             
          
           
          <i
            className="bi-chevron-down toggle-btn"
            onClick={() => setOpen(!open)}
          ></i>
        </div>
        <div className="sidebar-content">
          {item.childrens.map((child, index) => (
            <MediaSidebarItem key={index} item={child} onClick={showSideBar} />
          ))}
        </div>
      </div>
    );
  } else {
    return (
      <a href={item.path || "#"} className="sidebar-item  " onClick={showSideBar}>
        {item.icon && <item.icon className="sidebar-icon" />} {/* ✅ consistent */}
        {item.title}
      </a>
    );
  }
}
